import { useState } from 'react';
import type { ReportParameter } from 'src/components/star-grid/reportDefinition.types';
export const useStudioParameter = (parameter: ReportParameter, values: readonly string[]) => {
  const [open, setOpen] = useState(false);
  const labels = values.map((value) => parameter.options?.find((option) => option.value === value)?.label ?? value);
  return { open, setOpen, summary: labels.join(', ') };
};
